// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"search-module--searchPage--3qjRp","empty":"search-module--empty--2ifhU","info":"search-module--info--1bagN","title":"search-module--title--E-mnY"};